import { render, staticRenderFns } from "./AdminApp.vue?vue&type=template&id=1ae234ab&scoped=true"
import script from "./AdminApp.vue?vue&type=script&lang=js"
export * from "./AdminApp.vue?vue&type=script&lang=js"
import style0 from "./AdminApp.vue?vue&type=style&index=0&id=1ae234ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae234ab",
  null
  
)

export default component.exports